import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { getCurrency } from "src/utils/currencies";
import { fDecimalNumber } from "src/utils/formatNumber";

import Context from "../../../context";

// ----------------------------------------------------------------------

type Props = {
	shares: number;
	amount: number;
	currency: string;
};

export const RevisionResult = ({ amount, shares, currency }: Props) => {
	const { theme } = useContext(Context);

	return (
		<Stack alignItems={"flex-end"} direction={{ xs: "row", sm: "column" }}>
			<Typography
				noWrap
				variant='subtitle1'
				sx={{ mb: 0.5 }}
				fontSize={18}
				color={theme?.colors.primaryText}
			>
				{!amount || amount === 0
					? "N/A"
					: `${fDecimalNumber(amount * shares)} ${getCurrency(currency)}`}
			</Typography>
			<Typography
				variant='body1'
				noWrap
				sx={{ mb: 1, ml: { xs: 1, sm: 0 } }}
				fontSize={11}
				color={theme?.colors.secondaryText}
			>
				{`${fDecimalNumber(shares, true)} part.`}
			</Typography>
		</Stack>
	);
};

export default RevisionResult;
